/* eslint-disable no-console  */
import axios, { AxiosError, AxiosResponse } from "axios";
import { restoreUser } from "./user";

type User = {
  id: number;
  Token: string;
};
type Settings = {
  serverToken?: string | null;
  logging?: boolean;
};

function createApiClient(
  getUser?: () => User,
  onError?: (error: Error) => void,
  settings: Settings = {
    serverToken: null,
    logging: false,
  }
) {
  function log(...args: any) {
    if (settings && settings.logging === true) {
      console.log(...args);
    }
  }

  function dir(json: JSON) {
    if (settings && settings.logging === true) {
      console.dir(json, { depth: null, colors: true });
    }
  }

  const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  });

  instance.interceptors.request.use((req) => {
    if (typeof getUser === "function") {
      const { id = "", Token } = getUser();

      req.headers = {
        ...req.headers,
        Token: `${Token}`,
        user: id,
      };
    }

    if (settings.serverToken) {
      req.headers["Server-Token"] = settings.serverToken;
    }

    return req;
  });

  // allows throwing an error in the onFullfilled callback
  // @ts-expect-error we are overwriting the use method
  instance.interceptors.response.use_ = function (onFullfilled, onRejected) {
    instance.interceptors.response.use(
      // onFullfilled
      function (response) {
        try {
          return onFullfilled(response);
        } catch (e) {
          return onRejected(e);
        }
      },
      // onRejected
      onRejected
    );
  };

  // @ts-expect-error we are overwriting the use method
  instance.interceptors.response.use_(
    (res: AxiosResponse) => {
      log("\n");
      log("\n ⏰ === Request", res.config.url);
      log("🤖 --- Request Headers");
      dir(res.config.headers);

      log("\n 🤔 --- Request Data");
      if (res.config.data) {
        dir(JSON.parse(res.config.data));
      } else {
        log("- no data for this request -");
      }

      if (typeof res.data === "string") {
        console.log(`❌ === error parsing response`);
        console.log(res.data);
        console.log(`/==== ❌ error`, res.config.url);
        throw new Error("Invalid response.");
      }

      const { data } = res.data;

      log("\n 🚀 ___  Response Data");
      dir(data);

      log("/request === ✅", res.config.url);

      return data;
    },
    (err: AxiosError) => {
      if (err.response) {
        console.log(`❌ === error`);
        console.log(err.response);
        console.log(`/=== ❌`);

        if (typeof onError === "function") {
          onError(err.response.data.error);
        }

        // reformat the error message
        return Promise.reject(new Error(err.response.data.error.details));
      }

      return Promise.reject(err);
    }
  );

  return instance;
}

export default createApiClient;

export const apiClient = createApiClient(() => restoreUser());
